import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualNotaxinvoicePage } from './manual-notaxinvoice.page';

const routes: Routes = [
  {
    path: '',
    component: ManualNotaxinvoicePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualNotaxinvoicePageRoutingModule {}
